// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOGIN_COGNITO = 'LOGIN_COGNITO';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const SAVE_FIREBASE_USER = 'SAVE_FIREBASE_USER';
export const SAVE_COGNITO_USER = 'SAVE_COGNITO_USER';
export const SET_ASSOCIATE_SOFTWARE_TOKEN = 'SET_ASSOCIATE_SOFTWARE_TOKEN';
